/**
 * The client is supplied through context so a screen never imports a singleton and
 * tests can hand in a fake. `useApi()` is the only way to reach it.
 */

import { createContext, useContext, type ReactNode } from 'react';

import type { ApiClient } from '../client';

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) {
    throw new Error('useApi must be used inside <ApiProvider>. Check the app root.');
  }
  return client;
}
